import React from "react";
import { M44MediaViewer } from "../../M44MediaViewer";
export const SmartphoneFrameWithMedia = ({ frameImageUrl, mediaFileUrl, posterUrl, isVideoLooping, }) => (React.createElement("div", { className: "smartphone-frame-with-media" },
    React.createElement("div", { className: "smartphone-frame-with-media__container" },
        React.createElement(M44MediaViewer, { mediaFileUrl: mediaFileUrl, posterUrl: posterUrl, isVideoLooping: isVideoLooping }),
        React.createElement("img", { className: "smartphone-frame-with-media__frame", src: frameImageUrl, alt: "" }))));
